/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Offline_Low_Quality_WarningInputs */

const en_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some installed system voices may sound low quality. On Windows, install additional natural voices in Settings > Time & language > Speech.`)
};

const fr_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certaines voix système installées peuvent avoir une qualité médiocre. Sous Windows, installez des voix naturelles supplémentaires dans Paramètres > Heure et langue > Parole.`)
};

const de_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige der vorinstallierten Systemstimmen klingen möglicherweise von geringer Qualität. Unter Windows können Sie zusätzliche natürliche Stimmen unter Einstellungen > Zeit und Sprache > Sprache installieren.`)
};

const it_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcune voci di sistema installate potrebbero avere una qualità audio bassa. Su Windows, installa voci naturali aggiuntive in Impostazioni > Ora e lingua > Voce.`)
};

const ru_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Качество звучания некоторых установленных системных голосов может быть низким. В Windows установите дополнительные естественные голоса в разделе «Параметры» > «Время и язык» > «Речь».`)
};

const es_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es posible que algunas voces del sistema instaladas tengan baja calidad de sonido. En Windows, instale voces naturales adicionales en Configuración > Hora e idioma > Voz.`)
};

const zh_cn2_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`某些系统自带语音可能音质欠佳。在 Windows 系统中，您可以在“设置”>“时间和语言”>“语音”中安装其他自然语音。`)
};

const ja_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インストールされているシステム音声の中には、音質が低いものがあります。Windows では、「設定」＞「時刻と言語」＞「音声」で、追加の自然な音声をインストールしてください。`)
};

const hi_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुछ सिस्टम में पहले से इंस्टॉल की गई आवाज़ें कम गुणवत्ता वाली लग सकती हैं। विंडोज़ पर, सेटिंग्स > समय और भाषा > भाषण में जाकर अतिरिक्त प्राकृतिक आवाज़ें इंस्टॉल करें।`)
};

const pt_pt2_voice_manager_offline_low_quality_warning = /** @type {(inputs: Voice_Manager_Offline_Low_Quality_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algumas vozes de sistema instaladas podem ter baixa qualidade de som. No Windows, instale vozes naturais adicionais em Configurações > Hora e idioma > Fala.`)
};

/**
* | output |
* | --- |
* | "Some installed system voices may sound low quality. On Windows, install additional natural voices in Settings > Time & language > Speech." |
*
* @param {Voice_Manager_Offline_Low_Quality_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_offline_low_quality_warning = /** @type {((inputs?: Voice_Manager_Offline_Low_Quality_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Offline_Low_Quality_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "de") return de_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "it") return it_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "ru") return ru_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "es") return es_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "ja") return ja_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "hi") return hi_voice_manager_offline_low_quality_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_offline_low_quality_warning(inputs)
	return en_voice_manager_offline_low_quality_warning(inputs)
});